import { ColumnsType } from "antd/es/table";
import { Space, Dropdown, Tooltip, Tag } from "antd";
import { BotoesAcoes } from "../../ViewGerenciarPostagens/styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";
import ColumnSearch from "../../../components/ColumnSearch";
import VerifiedIcon from "@mui/icons-material/Verified";
import CancelIcon from "@mui/icons-material/Cancel";

export const Columns = (
  onClick: (e: any) => void,
  setParceiroId: (e: number) => void,
  filteredInfo: {
    nome?: string[] | null;
    descricao?: string[] | null;
    active?: number[] | null;
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Nome Parceiro",
      dataIndex: "nome",
      key: "nome",
      width: "30%",
      align: "center",
      render: (_, row) => (
        <Tooltip title={row.nome}>
          <Tag>{row.nome}</Tag>
        </Tooltip>
      ),
      filteredValue: filteredInfo.nome || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.nome.includes(value),
      ...ColumnSearch<any>({ dataIndex: "nome" }),
    },
    {
      title: "Descrição",
      dataIndex: "descricao",
      key: "descricao",
      width: "30%",
      align: "center",
      filteredValue: filteredInfo.descricao || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.descricao.includes(value),
      ...ColumnSearch<any>({ dataIndex: "descricao" }),
    },
    {
      title: "Ativo",
      dataIndex: "active",
      key: "active",
      width: "30%",
      align: "center",
      filters: [
        { text: "Ativo", value: 1 },
        { text: "Desativado", value: 0 },
      ],
      filteredValue: filteredInfo.active || null,
      onFilter: (value, record) => String(record.active) === String(value),
      filterSearch: true,
      render: (_, row) =>
        row.active == 1 ? (
          <Tooltip title="Ativo">
            <VerifiedIcon color="success" />
          </Tooltip>
        ) : row.active == 0 ? (
          <Tooltip title="Desativado">
            <CancelIcon color="error" />
          </Tooltip>
        ) : null,
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setParceiroId(row.id);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
